import { render, staticRenderFns } from "./AutoGroups.vue?vue&type=template&id=037e2c4c&scoped=true&"
import script from "./AutoGroups.vue?vue&type=script&lang=ts&"
export * from "./AutoGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037e2c4c",
  null
  
)

export default component.exports